import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Profile } from 'app/services/profile.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticatedGuard implements CanActivate {
  constructor(
    private profile: Profile,
    private router: Router,
    private messageService: MessageService,
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isUser: boolean = this.isUser();

    if (isUser) {
      this.messageService.add({
        severity: 'error',
        summary: 'Not Authorized',
        detail: `You don't have permission`,
      });
    }

    if (this.profile.isAuthenticated && !isUser) {
      return true;
    } else {
      this.router.navigate(['/auth', 'login']);
      return false;
    }
  }

  private isUser(): boolean {
    const user = this.profile.currentMe();
    if (user?.role === 'user') {
      this.profile.disposeUser();
      return true;
    }

    return false;
  }
}
